// import { createContext, useContext, useState, useEffect } from "react";
// import axios from "axios";

// const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
// const AuthContext = createContext(null);

// export const useAuth = () => useContext(AuthContext);

// export const AuthProvider = ({ children }) => {
//   const [user, setUser] = useState(null);
//   const [token, setToken] = useState(() => localStorage.getItem('rr_token'));
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     if (token) {
//       axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
//         .then(r => setUser(r.data))
//         .catch(() => { localStorage.removeItem('rr_token'); setToken(null); })
//         .finally(() => setLoading(false));
//     } else {
//       setLoading(false);
//     }
//   }, [token]);

//   const login = async (email, password) => {
//     const r = await axios.post(`${API}/auth/login`, { email, password });
//     setToken(r.data.token);
//     setUser(r.data);
//     localStorage.setItem('rr_token', r.data.token);
//     return r.data;
//   };

//   const register = async (name, email, phone, password) => {
//     const r = await axios.post(`${API}/auth/register`, { name, email, phone, password });
//     setToken(r.data.token);
//     setUser(r.data);
//     localStorage.setItem('rr_token', r.data.token);
//     return r.data;
//   };

//   // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
//   const loginWithGoogle = () => {
//     const redirectUrl = window.location.origin + '/login';
//     window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
//   };

//   const handleGoogleCallback = async (sessionId) => {
//     const r = await axios.post(`${API}/auth/google`, { session_id: sessionId });
//     setToken(r.data.token);
//     setUser(r.data);
//     localStorage.setItem('rr_token', r.data.token);
//     return r.data;
//   };

//   const logout = () => {
//     setUser(null);
//     setToken(null);
//     localStorage.removeItem('rr_token');
//   };

//   const authHeaders = () => token ? { Authorization: `Bearer ${token}` } : {};

//   return (
//     <AuthContext.Provider value={{ user, token, loading, login, register, loginWithGoogle, handleGoogleCallback, logout, authHeaders, API }}>
//       {children}
//     </AuthContext.Provider>
//   );
// };

import { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem('rr_token'));
  const [loading, setLoading] = useState(true);

  // Load user from local storage instantly (No API call needed for the pitch)
  useEffect(() => {
    const storedToken = localStorage.getItem('rr_token');
    const storedUser = localStorage.getItem('rr_user');
    if (storedToken && storedUser) {
      setToken(storedToken);
      setUser(JSON.parse(storedUser));
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    // Simulate a 1-second network loading delay so it feels real
    await new Promise(resolve => setTimeout(resolve, 1000));

    let mockUser = null;

    if (email === 'admin@rasraj.com' && password === 'admin123') {
      mockUser = { id: 1, name: 'Admin Ras Raj', email, role: 'admin', token: 'mock-admin-token' };
    } else if (email === 'delivery@rasraj.com' && password === 'delivery123') {
      mockUser = { id: 2, name: 'Delivery Partner', email, role: 'delivery_partner', token: 'mock-delivery-token' };
    } else if (email === 'user@rasraj.com' && password === 'user123') {
      mockUser = { id: 3, name: 'Rahul Tiwari', email, phone: '9876543210', role: 'customer', token: 'mock-user-token' };
    } else {
      throw { response: { data: { detail: 'Invalid credentials. Please use the demo accounts.' } } };
    }

    setToken(mockUser.token);
    setUser(mockUser);
    localStorage.setItem('rr_token', mockUser.token);
    localStorage.setItem('rr_user', JSON.stringify(mockUser));
    return mockUser;
  };

  const register = async (name, email, phone, password) => {
    await new Promise(resolve => setTimeout(resolve, 1000));
    const mockUser = { id: Math.floor(Math.random() * 1000), name, email, phone, role: 'customer', token: 'mock-new-user-token' };
    setToken(mockUser.token);
    setUser(mockUser);
    localStorage.setItem('rr_token', mockUser.token);
    localStorage.setItem('rr_user', JSON.stringify(mockUser));
    return mockUser;
  };

  const logout = () => {
    setUser(null);
    setToken(null);
    localStorage.removeItem('rr_token');
    localStorage.removeItem('rr_user');
  };

  const authHeaders = () => token ? { Authorization: `Bearer ${token}` } : {};

  return (
    <AuthContext.Provider value={{ user, token, loading, login, register, logout, authHeaders }}>
      {children}
    </AuthContext.Provider>
  );
};